// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"216":"8cb0f409","567":"ea7a0785","944":"e3eeca9d"}[chunkId] + ".chunk.css";
};